import apiUrl from "./config/config";
import axios from "axios";

class logApi
{

  //Get a log
  static async getLog(id)
  {

    try
    {

      const response = await axios(apiUrl + `log/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get list of logs
  static async getLogs(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "log/", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get list of logs by user
  static async getLogsByUser(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "log/user", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get list of logs by action
  static async getLogsByAction(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "log/action", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Add log
  static async addLog(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "log/", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a log
  static async deleteLog(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `log/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete multiple logs
  static async deleteLogs(params)
  {

    try
    {

      const response = await axios.delete(apiUrl + "log/", { data: params });

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

}

export default logApi;
